import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "First Responder Insurance Verification | Neuro Wellness TMS Centers of America",
  description:
    "First responders: submit your insurance information and our team will verify your benefits for TMS, SAINT, and mental health treatment.",
  canonical: "/first-responder-insurance-verification",
  keywords:
    "first responder insurance verification, first responder TMS coverage, police firefighter insurance benefits, first responder mental health insurance",
};

const relatedLinks = [
  { title: "TMS for First Responders", href: "/tms-for-first-responders" },
  { title: "How Insurance Works", href: "/how-insurance-works" },
  { title: "Cost & Insurance", href: "/cost-insurance" },
  { title: "Federal Employee Hub", href: "/federal-employee-mental-health" },
];

export default function FirstResponderInsuranceVerification() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Insurance Verification"
      title="First Responder Insurance Verification"
      subtitle="Submit your insurance information and our team will verify what treatment options may be available through your plan."
    >
      <DecisionSection heading="How verification works">
        <p>
          Many first responders have insurance through their employer — a
          municipal, county, or state government plan. Some have coverage
          through a spouse, a marketplace plan, or a federal employee plan (if
          employed by a federal agency).
        </p>
        <p>
          Coverage for TMS, SAINT, SPRAVATO, and other advanced treatments
          varies by individual plan. Our team handles the entire verification
          process:
        </p>
        <DecisionList
          items={[
            "We contact your insurer to verify behavioral health benefits",
            "We identify which treatments may be covered under your plan",
            "We gather clinical documentation and submit prior authorization",
            "We notify you of the decision and explain your costs before treatment",
            "If denied, we file an appeal with additional documentation",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="What to prepare">
        <DecisionList
          items={[
            "Your insurance card (front and back)",
            "A list of antidepressants you've tried, with approximate dates",
            "Your current prescriber's name and contact information",
            "Any prior TMS treatment records, if applicable",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Start now">
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or complete the verification form on our{" "}
          <Link to="/cost-insurance" className="text-accent hover:underline">
            cost and insurance page
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
